/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RepatriationOpportunityState = {
    Active: 'ACTIVE',
    Closed: 'CLOSED',
    Won: 'WON'
} as const;
export type RepatriationOpportunityState = typeof RepatriationOpportunityState[keyof typeof RepatriationOpportunityState];


export function instanceOfRepatriationOpportunityState(value: any): boolean {
    for (const key in RepatriationOpportunityState) {
        if (Object.prototype.hasOwnProperty.call(RepatriationOpportunityState, key)) {
            // @ts-ignore
            if (RepatriationOpportunityState[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RepatriationOpportunityStateFromJSON(json: any): RepatriationOpportunityState {
    return RepatriationOpportunityStateFromJSONTyped(json, false);
}

export function RepatriationOpportunityStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityState {
    return json as RepatriationOpportunityState;
}

export function RepatriationOpportunityStateToJSON(value?: RepatriationOpportunityState | null): any {
    return value as any;
}

